import { toast } from "react-toastify";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";

export const addRegion = async (regionId: string) => {
  try {
    const response = await post<ApiResponse<[]>>(`/user/regions`, {
      regionId: regionId,
    }).then((res) => {
      if (res?.success === true) {
        return res;
      } else {
        return null;
      }
    });
    return response;
  } catch (error) {
    HandleApiError(error);
  }
};
